/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
export class Subject {

    id: number;
    uuid: string;
    code: string;

    firstname: string;
    surname: string;
    description: string;
    photo: string;
    email: string;
    mobileNumber: string;
    workPhoneNumber: string;
    bio: string;
    initials: string;
    birthDate: Date;

    password: string;
    usuarioAPP: boolean;

    ciudad: string;
    direccion: string;

    usuarioOwner: boolean = true;
    
    nui: string;
    
    subjectType:string; //Tipo de persona: NATURAL ó JURIDICA
    
    noTieneCorreoElectronico: boolean = false; //false Usa un correo electrónico propio, true usa un correo electrónico de un asistente
    esExtranjero: boolean = false; //false No es extrajero, true es extranjero no validar cédula
    
     esCedulaDiferenteAlRUC: boolean = false;//false usa el mismo numero de RUC como cédula
    esPersonaNatural: boolean = true;//false usa el mismo numero de RUC como cédula
}

